"use client";

import { LinkIcon } from "@heroicons/react/24/outline";
import { Button, handleCopyClipboard } from "@ubud-ui/react-ui-kit";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { FacebookIcon, LinkedinIcon, WhatsappIcon, XIcon } from "../custom-icon";
import { usePathname } from "next/navigation";
import { useClientConfig } from "@providers/app-provider/client-app-provider";

export function PageShareButtons() {
  const clientConfig = useClientConfig();

  const url = clientConfig?.config.appUrl + usePathname();

  return (
    <div className="mt-6 sm:mt-10 text-lg flex gap-4 items-center">
      <div className="font-medium text-sm">Bagikan:</div>
      <div className="flex-1 flex items-center gap-3">
        <WhatsappShareButton url={url}>
          <WhatsappIcon className="size-5 text-gray-600" />
        </WhatsappShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon className="size-5 text-gray-600" />
        </LinkedinShareButton>
        <TwitterShareButton url={url}>
          <XIcon className="size-5 text-gray-600" />
        </TwitterShareButton>
        <FacebookShareButton url={url}>
          <FacebookIcon className="size-5 text-gray-600" />
        </FacebookShareButton>
        <Button size="icon" variant="ghost" className="size-5" onClick={() => handleCopyClipboard(url)}>
          <LinkIcon className="size-5 text-gray-600" />
        </Button>
      </div>
    </div>
  );
}
